import {
  Auth,
  UserRole,
  UserRoleKey,
} from 'apollo/generated/client-operations';

const ContractorMemberRoles = [
  UserRoleKey.ContractorAdmin,
  UserRoleKey.ContractorForeman,
  UserRoleKey.ContractorReader,
  UserRoleKey.ContractorEditor,
];

export const isContractorMemberRoleKey = (roleKey: UserRoleKey): boolean => {
  return ContractorMemberRoles.includes(roleKey);
};

export const isContractorMemberUser = (user: {
  roles: Pick<UserRole, 'key'>[];
}): boolean => {
  return (
    user?.roles.some((role) => isContractorMemberRoleKey(role.key)) ?? false
  );
};

export const isContractorUserSession = (currentSession: Auth): boolean => {
  return currentSession?.user
    ? isContractorMemberUser(currentSession?.user)
    : false;
};

const ContractorPortalRoles = [
  UserRoleKey.ContractorAdmin,
  UserRoleKey.ContractorForeman,
  UserRoleKey.ContractorReader,
  UserRoleKey.ContractorEditor,
  UserRoleKey.Worker,
];

/** A contractor admin who does not also hold a broader portal role. */
export const isContractorAdminPortal = (
  user?: {
    roles?: Array<{ key?: UserRoleKey | null }> | null;
  } | null,
): boolean => {
  const keys = (user?.roles ?? [])
    .map((role) => role.key)
    .filter((key): key is UserRoleKey => Boolean(key));
  return (
    keys.includes(UserRoleKey.ContractorAdmin) &&
    keys.every((key) => ContractorPortalRoles.includes(key))
  );
};

export const contractorAdminIds = (
  user?: {
    roles?: Array<{
      key?: UserRoleKey | null;
      object?: { objectId?: string | null } | null;
    }> | null;
  } | null,
): string[] =>
  (user?.roles ?? [])
    .filter(
      (role) =>
        role.key === UserRoleKey.ContractorAdmin && role.object?.objectId,
    )
    .map((role) => role.object?.objectId as string);
